<template>
  <div class="hstack justify-content-between w-100" v-if="!editForm">
    <div class="px-1 rounded" :class="hoverClass" @click="inScope ? enableEdit() : $emit('addTranslation', previousTranslation)" v-tooltip="tooltipText">
      <span v-if="translationText.trim()">{{ translationText }}</span>
      <span v-else class="text-muted small">[ blank ]</span>
    </div>
    <span v-if="translation.suggest_default" class="badge bg-primary">{{ $t("js.backend.translations.suggested_default") }}</span>
  </div>
  <div v-else class="edit-field flex-grow-1">
    <div class=" flex-grow-1">
      <div class="d-flex justify-content-between align-items-center mb-1">
          <span class="small text-success text-center" v-if="newTranslation">{{ $t('js.backend.translations.new_for_scope', {scope: $t(`js.backend.translations.scopes.${translation.scope_type}`)}) }}</span>
          <span class="small text-danger text-center" v-else-if="destroy">{{ $t('js.backend.translations.delete_for_scope', {scope: $t(`js.backend.translations.scopes.${translation.scope_type}`)}) }}</span>
          <span class="small text-primary text-center" v-else>{{ $t('js.backend.translations.edit_for_scope', {scope: $t(`js.backend.translations.scopes.${translation.scope_type}`)}) }}</span>
        <div>
          <button @click.prevent="submit" type="button" class="btn btn-outline-primary py-0 me-1"><i class="fas fa-save"></i></button>
          <button v-if="!destroy && !newTranslation" @click.prevent="destroy = true" type="button" class="btn btn-outline-danger py-0 me-1"><i class="fas fa-trash-alt"></i></button>
          <button v-else-if="destroy && !newTranslation" @click.prevent="destroy = false" type="button" class="btn btn-outline-danger py-0 me-1"><i class="fas fa-undo fa-sm"></i></button>
          <button @click.prevent="disableEdit(true)" type="button" class="btn btn-outline-dark py-0 "><i class="fas fa-times fa-sm"></i></button>
        </div>
      </div>
      <textarea class="form-control" :rows="rows" type="input" :ref="'field'"
      :class="destroy ? 'rounded border border-danger text-black-50' : ''"
      v-model="translation.translated_text">
      </textarea>
      <div class="form-check form-switch mt-3" v-if="translation.scope_type === 'Site'">
        <input id="suggest_default" type="checkbox" class="form-check-input" :ref="'s'"
               v-model="translation.suggest_default">
        <label for="suggest_default" class="form-check-label"
               v-text="$t('js.backend.translations.suggest_default')"></label>
      </div>
    </div>
  </div>
</template>
<script>
    import apiClient from "../../entrypoints/frontend/apiClient.js"
    export default {
        name: "Translation",
        props: {
          previousTranslation: Object,
          scope: Object,
          tkey: String,
          tightScopeExist: Boolean
        },
      data(){
          return {
            editForm: false,
            destroy: false,
            translation: Object.assign({}, this.previousTranslation)
          }
      },
      computed: {
        inScope(){
          return this.translation.scope_type === this.scope.type && this.translation.scope_id === this.scope.id
        },
        newTranslation(){
          return !this.translation.created_at
        },
        translationText(){
          return this.translation.translated_text || this.translation.default_text || ""
        },
        hoverClass(){
          if(this.tightScopeExist && !this.inScope)
            return 'uneditable'
          return this.inScope ? 'editable' : 'creatable'
        },
        tooltipText(){
          if(this.tightScopeExist && !this.inScope)
            return this.$t('js.tooltips.translation.show_current')
          return this.inScope ? this.$t('js.tooltips.translation.edit', {scope: this.$t(`js.backend.translations.scopes.${this.scope.type}`)}) : this.$t('js.tooltips.translation.create_new_under_scope', {scope: this.$t(`js.backend.translations.scopes.${this.scope.type}`)})
        },
        rows(){
          if(!this.translation.translated_text)
            return 1
          if(this.translation.translated_text.length < 100){
            return 1
          } else if(this.translation.translated_text.length < 200){
            return 2
          } else {
            return 5
          }

        }
      },
      methods: {
        enableEdit(){
          if(!this.translation.translated_text){
            this.translation.translated_text = this.translation.default_text
          }
          this.editForm = true
          this.$nextTick(function () {
            let textArea = this.$refs.field
            let fldLength= textArea.value.length;
            textArea.focus()
            textArea.setSelectionRange(fldLength, fldLength);
          })
        },
        disableEdit(reset = false){
          if(reset){
            if(this.newTranslation){
              this.$emit('removeTranslation', this.previousTranslation)
            } else {
              this.destroy = false
              this.translation = Object.assign({}, this.previousTranslation)
            }
          }
          this.editForm = false
        },
        submit(){
          if(this.destroy){
            apiClient.delete(`/backend/translations/${this.translation.id}`).then(res => {
              this.$emit('removeTranslation', this.previousTranslation)
            }).catch(() => { this.disableEdit(true) })
          } else if(this.newTranslation){
            apiClient.post("/backend/translations", {translation: this.translation}).then(res => {
              this.$emit('changeTranslation', this.previousTranslation, res.data)
              this.disableEdit()
            }).catch(() => { this.disableEdit(true) })
          } else {
            apiClient.put(`/backend/translations/${this.translation.id}`, {translation: this.translation}).then(res => {
              this.$emit('changeTranslation', this.previousTranslation, res.data)
              this.disableEdit()
            }).catch(() => { this.disableEdit(true) })
          }
        }
      },
      mounted(){
        if(this.newTranslation)
          this.enableEdit()
      }
    }
</script>